import { setTheme } from "theme/default/setTheme";

export const color_rgba_0_0_0_07 = setTheme(({ theme }) => theme.colors.color_rgba_0_0_0_07);
